import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-the-page-j04" }
const _hoisted_2 = { class: "p-the-page-j04__inner" }
const _hoisted_3 = { class: "p-the-page-j04__image" }
const _hoisted_4 = { class: "p-the-page-j04__body" }
const _hoisted_5 = { class: "p-the-page-j04__body__text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconNoSearchResult = _resolveComponent("IconNoSearchResult")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_IconNoSearchResult, { "icon-size": _ctx.iconSize }, null, 8, ["icon-size"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("p", null, [
            _createTextVNode(" 「" + _toDisplayString(_ctx.searchKeyword) + "」に一致する結果は ", 1),
            _cache[0] || (_cache[0] = _createElementVNode("br", { class: "u-display-none--pc" }, null, -1)),
            _cache[1] || (_cache[1] = _createTextVNode("ありませんでした ", -1))
          ]),
          _cache[2] || (_cache[2] = _createElementVNode("p", { class: "p-the-page-j04__body__text--primary" }, " 別のキーワードで検索してください ", -1))
        ])
      ])
    ])
  ]))
}